import { AgentDevice } from '@models/agent-device.model';
import { Agent } from '@models/agent.model';
import { HybridOSType } from '@modules/test-development/components/run-results/machine-config/hybrid-os-type';
import { LabOSType } from '@modules/test-development/components/run-results/machine-config/lab-os-type';
import { TestPlanLabType } from '@modules/test-development/enums/test-plan-lab-type.enum';
import { TestDevice } from '@testsigmainc/models';

interface OSTypeProps {
  testDevice: TestDevice;
  agent?: Agent;
  agentDevice?: AgentDevice;
  className?: string;
  variant?: 'detail' | 'concise';
}

export const OSType: React.FC<OSTypeProps> = ({
  testDevice,
  agent,
  agentDevice,
  className,
  variant = 'concise',
}) => {
  if (testDevice.executionLabType == TestPlanLabType.Hybrid) {
    const os = agent?.system?.osType;
    const osVersion = agent?.system?.osVersion;
    return (
      <HybridOSType
        osType={os}
        osVersion={osVersion}
        className={className}
        variant={variant}
      />
    );
  }
  const os =
    testDevice.platformOsVersion?.platform ||
    testDevice.platform ||
    testDevice?.platformDevice?.platform;
  const osVersion =
    testDevice.platformOsVersion?.version ||
    testDevice?.platformDevice?.osVersion;
  return (
    <LabOSType
      osType={os}
      osVersion={osVersion}
      className={className}
      variant={variant}
    />
  );
};
